import scrollBarWidth from 'scrollbarwidth'

export function toggleScrollbar(opened) {
  const scrollbar = scrollBarWidth()
  document.body.style.setProperty(
    '--scrollbar-width',
    opened ? `${scrollbar}px` : 0
  )
}
